export const listMonths = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
]

export const listMonthsNice = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export const newDate = (date, toString) =>
  toString
    ? new Date(date || new Date().toString()).toString()
    : new Date(date || new Date().toString())

export const dateLastDayOfMonth = (month, year) =>
  new Date(year, listMonths.indexOf(month) + 1, 0)

export const getNextDay = date => new Date(date.setDate(date.getDate() + 1))

export const currentMonth = listMonths[newDate().getMonth()]
export const currentYear = new Date().getFullYear()
